import { Button, Container, Dialog, Grid, IconButton, Paper, Stack, Typography, Box } from '@mui/material';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { BASE_URL, calculateAge, getCurrentDateTime, request, toast } from '../../../../../utils';
import { useCallback, useEffect, useState } from 'react';
import { REPORT_TYPE } from '../../../../../constants/dropdown';
import { CollectionSummaryReport } from './CollectionSummaryReport';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

const initialSchemeAllotmentDataObj = {
  data: [],
  loading: false
};

export const CollectionSummary = () => {
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const [openPrint, setOpenPrint] = useState(false);
  const [userdata, setUserData] = useState([]);
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        from_date: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      from_date: new Date().toISOString().split('T')[0],
      to_date: new Date().toISOString().split('T')[0],
      report: 'bill_wise_collection'
    },
    mode: 'all'
  });

  const { handleSubmit, watch, setValue, reset } = methods;
  const user = JSON.parse(localStorage.getItem('user'));
  console.log('HELLLLLLO USERSSSS', user);
  const getUserList = useCallback(async () => {
    try {
      const response = await axios.get(`${BASE_URL}/user`);
      setUserData(response.data);
    } catch (error) {
      console.error('Error fetching user list:', error);
    }
  }, []);
  useEffect(() => {
    getUserList();
  }, []);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  const handleExcelReport = async () => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const response = await axios.get(
      `${BASE_URL}/print/hospital/mis-report/collection-summary/user-wise?refId=${JSON.stringify({ report: watch('report'), user: watch('user'), from_date: watch('from_date'), to_date: watch('to_date') })}`
    );
  
    if (response.data.success) {
      const opdData = response?.data?.data?.opdData?.data;
      const opdBillingData = response?.data?.data?.opdBillingData?.data;
      const allData = [];
      // Process opdData
      if (opdData && opdData.length > 0) {
        const formattedOpdData = opdData.map((item, index) => ({
          'Sr. No.': index + 1,
          "Type": "OPD",
          'Bill Date': formatDate(item?.date),
          'Opd Type': item?.opdtypeData?.type,
          'Patient Name': `${item?.name_suffix} ${item?.first_name} ${item?.last_name}`,
          'Age' : calculateAge(item?.dob),
          'Uhid No.': item?.uhid,
          'reffered_by':item?.ref_by?.referral_name,
          'Paymode': item?.payment_mode,
          'Consultant': item?.consultant?.name,
          'Services': 'Consultancy',
          'Panel': item?.sponsor?.name,
          'Bill Amt': item?.reg,
          'Dis Amt.': item?.disc,
          'Recd Amt.': item?.recd,
          'Bal. Amt.': item?.bal,
          'User Name': item?.createdBy
        }));
        allData.push(...formattedOpdData);
      }
      // Process opdBillingData
      if (opdBillingData && opdBillingData.length > 0) {
        const formattedOpdBillingData = opdBillingData.map((item, index) => {
          const combinedServices = item?.combinedServiceDetails?.map(service => service?.service_name).join(", ") || '';
          return {
            'Sr. No.': index + 1,
            'Type': "OPD BILLING",
            'Bill Date': formatDate(item?.date),
            'Opd Type': item?.patient?.opdtypeData?.type,
            'Patient Name': `${item?.patient?.name_suffix} ${item?.patient?.first_name} ${item?.patient?.last_name}`,
            'Age' : calculateAge(item?.patient?.dob),
            'Uhid No.': item?.uhid,
            'reffered_by':item?.patient?.ref_by?.referral_name,
            'Paymode': item?.pay_mode,
            'Consultant': item?.patient?.consultant?.name,
            'Services': combinedServices,
            'Panel': item?.patient?.sponsor?.name,
            'Bill Amt': item?.total_amt,
            'Dis Amt.': item?.disc_amt,
            'Recd Amt.': item?.total_recd,
            'Bal. Amt.': item?.balance_amt,
            'User Name': item?.createdBy
          };
        });
        allData.push(...formattedOpdBillingData);
      }
  
      if (allData.length > 0) {
        console.log('Combined Data: ', allData);
        const fileName = `UserWise_Collection_Summary_${watch('from_date')}_to_${watch('to_date')}`;
  
        // Create sheet
        const ws = XLSX.utils.json_to_sheet(allData);
  
        // Set custom column widths (in characters)
        ws['!cols'] = [
          { wch: 5 },  // Sr. No. column width
          { wch: 15 }, // Type column width (extra width)
          { wch: 10 }, // Bill Date column width
          { wch: 10 }, // Opd Type column width
          { wch: 30 }, // Patient Name column width
          { wch: 15 }, // Uhid No. column width
          { wch: 25 }, // Uhid No. column width
          { wch: 10 }, // Paymode column width
          { wch: 30 }, // Consultant column width
          { wch: 30 }, // Services column width (extra width)
          { wch: 15 }, // Panel column width
          { wch: 10 }, // Bill Amt column width
          { wch: 10 }, // Dis Amt. column width
          { wch: 10 }, // Recd Amt. column width
          { wch: 10 }, // Bal. Amt. column width
          { wch: 20 }  // User Name column width
        ];
  
        // Create the workbook
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
  
        // Write the workbook to an array
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  
        // Save the file
        const data = new Blob([excelBuffer], { type: fileType });
        saveAs(data, fileName + fileExtension);
      } else {
        toast('No Data Found For These Filters', { variant: 'error' });
      }
    } else {
      toast('Something Went Wrong', { variant: 'error' });
    }
  };
  
  

  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Collection Summary Report
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button
                  variant="contained"
                  disabled={!watch('report')}
                  id={`${lastPathSegment}Print`}
                  onClick={() => 
                    window.open(
                      `/print${pathname}${watch('report') === 'user_wise_collection' ? '/user' : watch('report') === 'ref-by-collection' ? '/ref-by-collection' : ''}?refId=${JSON.stringify({ 
                        report: watch('report'), 
                        user: watch('user'), 
                        from_date: watch('from_date'), 
                        to_date: watch('to_date') 
                      })}`, 
                      '_blank'
                    )
                  }
                  
                >
                  View Pdf Report
                </Button>
                <Button
                  variant="contained"
                  disabled={!watch('report')}
                  id={`${lastPathSegment}Print`}
                  onClick={handleExcelReport}
                >
                  View Excel Report
                </Button>
                <Button variant="contained">Exit</Button>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '60%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={11} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>From Date</Typography>
                    <TextField sx={{ flex: 0.8 }} name="from_date" type="date" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>To Date</Typography>
                    <TextField sx={{ flex: 0.8 }} name="to_date" type="date" />
                  </Stack>
                  <Stack direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Report Type</Typography>
                    <SelectTag formControlSX={{ flex: 0.8 }} name="report" menus={REPORT_TYPE} />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>User</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.8 }}
                      name="user"
                      disabled={watch("report") === "bill_wise_collection"}
                      menus={[{ name: 'All', _id: 'all' },
                        ...(Array?.isArray(userdata) ? userdata?.map((data) => ({
                       ...data,
                        name: `${data.first_name} ${data.last_name}`, _id: `${data.first_name} ${data.last_name} `
                       
                        })) : [])
                        ]}
                    />
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openPrint}
        onClose={() => setOpenPrint(false)}
        PaperProps={{ sx: { width: '80%', height: '85%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <CollectionSummaryReport />
      </Dialog>
    </>
  );
};
